import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/lib/apiClient";
import { queryKeys } from "@/lib/query";
import type { FinancierItem } from "@/types/api/financier";

export function useFinancierById(id: string | undefined) {
  return useQuery({
    queryKey: queryKeys.financiers.detail(id ?? ""),
    queryFn: () => apiClient.getData<FinancierItem>(`/financiers/${id}`),
    enabled: !!id,
  });
}
